import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmModel {
  title: string;
  header: { key: string, label: string }[];
  data: { [key: string]: { type: string, value: any } }[];
}

@Component({
  selector: 'app-modal-tabla-detalle',
  templateUrl: './modal-tabla-detalle.component.html',
  styleUrls: ['./modal-tabla-detalle.component.scss']
})
export class ModalTablaDetalleComponent {

  confirmData: ConfirmModel = {
    title: '',
    header: [],
    data: []
  };

  constructor(
    public dialogRef: MatDialogRef<ModalTablaDetalleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModel
  ) {
    if(data && Object.keys(data).length > 0) {
      this.confirmData = data;
    }
  }

  close() {
    this.dialogRef.close(false);
  }

}
